// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"31d6cfe0","132":"8b1de72a","648":"afd73edf","954":"31d6cfe0"}[chunkId] + ".chunk.css";
};